import BookingRoleDto from '@/models/BookingRoles/BookingRoleDto';
import BookingDateDto from '@/models/BookingDates/BookingDateDto';
import LocationDto from '@/models/Locations/LocationDto';
import BranchDto from '@/models/Branches/BranchDto';
import BaseCompanyScopeEntityDto from '@/models/Shared/BaseCompanyScopeEntityDto';
import AgencyUserDto from '@/models/AgencyUsers/AgencyUserDto';
import GeneralStatus from '@/models/Shared/GeneralStatus';
import DepartmentDto from '@/models/Departments/DepartmentDto';

export default class BookingDto extends BaseCompanyScopeEntityDto {
    sequenceNumber = 0;
    status: GeneralStatus = GeneralStatus.ActiveOrApproved;
    ownerId: string;
    owner: AgencyUserDto = new AgencyUserDto();
    branchId: string;
    branch: BranchDto;
    locationId: string;
    location: LocationDto = new LocationDto();
    departmentId: string;
    department: DepartmentDto = new DepartmentDto();
    startAt: Date;
    endAt: Date;
    isTest = false;
    testEmailAddresses = '';
    purchaseOrderNumber = '';
    instructions = '';
    dates: BookingDateDto[] = [];
    roles: BookingRoleDto[] = [];
}